import { ManifestationOfflineDataFetcher, OfflineDataFetcher } from '@skinsoft/data-store';
import { EntityDataStore } from '@skinsoft/entity-data-store';
import { fetch } from '@skinsoft/network';
import { API_ENDPOINTS } from '../..';
import { catchError, delayWhen, distinctUntilChanged, last, tap } from 'rxjs/operators';
import { EMPTY, throwError } from 'rxjs';
import { isEqual } from 'lodash';

export interface Manifestation {
    id: string;
    type: string;
}

declare var MANIFESTATION_SEARCH_TYPES: string[];

export class ManifestationDataStore extends EntityDataStore<Manifestation> {
    public static getInstance() {
        if (!ManifestationDataStore.instance) {
            ManifestationDataStore.instance = new ManifestationDataStore();
        }

        return ManifestationDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$manifestationDataStore = ManifestationDataStore.getInstance();
    }

    private static instance: ManifestationDataStore = null as any;

    constructor() {
        super('manifestations', MANIFESTATION_SEARCH_TYPES);
    }

    public update(id: string, body: Partial<Manifestation>, endpointOverride?: string, ignoreCachedStatus: boolean = false) {
        return super.update(id, body, endpointOverride || API_ENDPOINTS[body.type as string], ignoreCachedStatus)
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new ManifestationOfflineDataFetcher(this.sanitizedIdentifer);
    }

    private getManifestationTypeEndpoint(itemType: string): string {
        const itemTypeArray = itemType.match(/(.*?)([A-Z].*?)([A-Z].*)/)?.slice(1)
        if (itemTypeArray) {
            itemTypeArray.splice(2, 1, 'manifestations')
            return itemTypeArray.join('-').toLowerCase()
        }

        return this.endpoint
    }

    public fetchOneWithItemType(id: string, itemType: string, networkFirst: boolean = false) {
        if (window.navigator.onLine && !OfflineDataFetcher.isTemporaryId(id)) {
            const uri = `/${this.getManifestationTypeEndpoint(itemType)}/${id}`;

            const network$ = this.proxy.fetch(uri, undefined, undefined, undefined, networkFirst).pipe(
                tap(data => this.offlineDataFetcher.updateOne(data.id, data)),
                last(),
                catchError(error => (fetch.isNetworkError(error) ? EMPTY : throwError(error))),
            );
            let source$ = network$;

            if (networkFirst) {
                source$ = source$.pipe(delayWhen(() => network$));
            }

            return source$.pipe(
                distinctUntilChanged(isEqual),
                this.mergeUpdateCacheDataToOneResult.bind(this),
            );
        }
        // if offline
        else {
            return this.fetchOneOfflineMode(id);
        }
    }
}
